import React from "react";
import { Button } from "@trussle/external-components";
import { ICalculatorResultsV2 } from "../../types/ICalculatorResults";
import "./styles.scss";

export const currencyFormatter = new Intl.NumberFormat("en-GB", {
  currency: "GBP",
  style: "currency",
});

export const CalculatorResultsV2: React.FunctionComponent<ICalculatorResultsV2> = (
  props: ICalculatorResultsV2,
) => {
  const {
    top: { title, result, subTitle },
    cta: {
      title: ctaText, handleClick: ctaHandleClick, color,
    },
    TopResultComponent,
  } = props;

  return (
    <div
      className="calculatorResults__container"
      role="region"
      aria-label="Calculator results"
    >
      {
        TopResultComponent
          ? <TopResultComponent />
          : (
            <div className="calculatorResults">
              <span>{title}</span>
              <span>{result}</span>
              <span>{subTitle}</span>
            </div>
          )
      }
      <div className="calculatorResults__bottom">
        <Button
          role="button"
          aria-label="Calculator results button"
          colour={color}
          onClick={ctaHandleClick}
          fixed
          className="calculatorResults__bottom__cta"
        >
          {ctaText}
        </Button>
      </div>
    </div>
  );
};
